import { render } from "./ImageManagement.vue?vue&type=template&id=b0939328"
import script from "./ImageManagement.vue?vue&type=script&lang=js"
export * from "./ImageManagement.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__